<template>
    <div class="bg-color-granite pb-10">
		<div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"			
				:height="199"
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="My Performance" /></h1>
			</div>			
		</div>
        <div class="bg-color-granite w-100 h-100">
            <div class="bg-color-quartz w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 bg-color-dell-blue tx-color-white">
                    <v-col cols="10" class="d-flex flex-column justify-start w-100 pa-0 py-8 tx-font-normal tx-font-size20">  
                        <v-row no-gutters>
                            <div class="body-text">
                            <p class="pb-2">
                                <LanguagePlaceholder is-html
                                    default-text="​​​​​​​​​​​Track your RISE performance throughout the incentive period to see how much you have earned and what you need to do to reach your reward multiplier thresholds." />
                            </p>
            
                            <p class="pb-2">
                                <LanguagePlaceholder is-html
                                    default-text="​​​​​You can see which products are eligible for rewards on the <route class='dell-white' route-name='home-eligible-products'style='text-decoration: underline;'>Eligible Products</route> page. On this page, you can also check which products count towards your reward multiplier thresholds." />
                            </p>
                   
                            <p class="pb-2">
                                <LanguagePlaceholder is-html
                                    default-text="For more information and support on anything related to your purchases, rewards or your performance, visit the <route class='dell-white' route-name='faq' style='text-decoration: underline;'>Help Center</route>." />
                            </p>
                
                        </div>
                        </v-row>          
                    </v-col>
                </v-row>
            </div>
        </div>
        <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
            <v-row no-gutters class="bg-color-quartz d-flex justify-center w-100">
            <v-col cols="1" class="bg-color-quartz pa-5"></v-col>
            <v-col cols="10" class="d-flex justify-start flex-column w-100 my-5 pb-10 tx-font-bold bg-color-white">  
                <div class="ma-0 pa-5 mb-10 bg-color-cobalt tx-color-white tx-font-normal">
                    <LanguagePlaceholder is-html
                                            default-text="​​​​​​Use the ‘Incentive Period’ dropdown to view your performance across different RISE incentive periods. Your report will reflect the reward multipliers and thresholds that were applicable in that incentive period. Data is provided by Distributors 2 weeks in arrears." />
                </div>
                <v-select  v-model="selectedQuarter" class="w-25 ps-14"
                    :items="quarters" variant="outlined"
                    aria-label="Select Incentive Period">
                    <template v-slot:label>
                        <LanguagePlaceholder
                            is-html
                            default-text="Select Incentive Period" />
                    </template>
                </v-select>
                <div class="w-25 ps-14">
                    <v-btn @click="clickSubmit" color="primary"  variant="outlined">
                        <LanguagePlaceholder default-text="Submit" />
                    </v-btn>                      
                </div>
                  
            </v-col>
            <v-col cols="1" class="bg-color-quartz"></v-col>
            </v-row>
        </div>
        <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
            <v-row no-gutters class="bg-color-quartz d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-white my-5 d-flex flex-column justify-center w-100 tx-font-bold">  
                    <div class="d-flex justify-center flex-row w-100">
                        <v-card class="w-100 pa-5 elevation-0">
                            <v-card-title class="text-subtitle-1"
                                style="background-color: #0C32A4; color:white;">
                                <LanguagePlaceholder  default-text="Total $ Core Rewards" />
                                </v-card-title>
                            <v-card-text class="text-center pt-4" style="background-color: #1D65C0;"
                                color="#ffffff">
                                <div class="tx-color-white tx-font-bolder tx-font-size32">
                                    {{ $filters.currencyUSD(myPerformanceData.totalDollarCoreRewards) }}
                                </div>
                            </v-card-text>
                        </v-card>

                        <v-card class="w-100 pa-5 elevation-0">
                            <v-card-title class="text-subtitle-1"
                                style="background-color: #0C32A4; color:white;">
                                <LanguagePlaceholder  default-text="Total $ Bonus Rewards" />                                    
                            </v-card-title>
                            <v-card-text class="text-center pt-4" style="background-color: #1D65C0;"
                                color="#cbeeff">
                                <div class="tx-color-white tx-font-bolder tx-font-size32">
                                    {{ $filters.currencyUSD(myPerformanceData.totalDollarBonusRewards) }}
                                </div>

                            </v-card-text>
                        </v-card>

                        <v-card class="w-100 pa-5 elevation-0">
                            <v-card-title class="text-subtitle-1"
                                style="background-color: #0C32A4; color:white;">
                                <LanguagePlaceholder default-text="Total $ Rewards" />
                                </v-card-title>
                            <v-card-text class="text-center pt-4" style="background-color: #1D65C0;"
                                color="#cbeeff">
                                <div class="tx-color-white tx-font-bolder tx-font-size32">
                                    {{ $filters.currencyUSD(myPerformanceData.totalDollarRewards) }}
                                </div>

                            </v-card-text>
                        </v-card>
                    </div>
                    <div class="d-flex justify-center flex-row w-100">
                        <v-card class="w-100 pa-5 elevation-0">
                            <v-card-title class="text-subtitle-1"
                                style="background-color: #0C32A4; color:white;"><v-icon
                                    class="mx-2">mdi-keyboard</v-icon>
                                    <LanguagePlaceholder default-text="PCs+ Displays+Peripherals" />
                                    
                                </v-card-title>
                            <v-card-text class="text-center pa-0">
                                <v-row no-gutters class="text-body-1" style="height: 120px;">
                                    <v-col class="pa-2" style="background-color: #58A5E6">
                                        <div class="mt-4 tx-color-white tx-font-normal tx-font-size16">
                                            <LanguagePlaceholder default-text="Total Eligible Units This Incentive Period (Nett inclusive of returns)" />
                                            
                                        </div>
                                    </v-col>
                                    <v-col class="pa-2" style="background-color: #0672CB">
                                        <div class="my-4 tx-color-white tx-font-normal tx-font-size16">
                                            <LanguagePlaceholder default-text="Total Eligible Units Last Four Incentive Periods" />
                                            </div>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="text-body-1" style="color:#102053">
                                    <v-col class="pa-2" style="background-color: #58A5E6">
                                        <div class="mt-4 tx-color-white tx-font-bolder tx-font-size32">{{ myPerformanceData.csG_Units_ThisPeriod }}</div>
                                    </v-col>
                                    <v-col class="pa-2" style="background-color: #0672CB">
                                        <div class="my-4 tx-color-white tx-font-bolder tx-font-size32">{{ myPerformanceData.csG_Units_LastFourPeriods }}</div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <v-card class="w-100 pa-5 elevation-0">
                            <v-card-title class="text-subtitle-1"
                                style="background-color: #0C32A4; color:white;"><v-icon
                                    class="mx-2">mdi-server</v-icon>
                                    <LanguagePlaceholder default-text="Server+" />
                                    </v-card-title>
                            <v-card-text class="text-center pa-0">
                                <v-row no-gutters class="text-body-1" style="height: 120px;">
                                    <v-col class="pa-2" style="background-color: #58A5E6">
                                        <div class="mt-4 tx-color-white tx-font-normal tx-font-size16">
                                            <LanguagePlaceholder default-text="Total Eligible Units This Incentive Period" />
                                            
                                        </div>
                                    </v-col>
                                    <v-col class="pa-2" style="background-color: #0672CB">

                                        <div class="my-4 tx-color-white tx-font-normal tx-font-size16">
                                            <LanguagePlaceholder default-text="Total Eligible Units Last Four Incentive Periods" />
                                            </div>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="text-body-1" style="color:#102053">
                                    <v-col class="pa-2" style="background-color: #58A5E6">
                                        <div class="mt-4 tx-color-white tx-font-bolder tx-font-size32">{{ myPerformanceData.server_Units_ThisPeriod }}</div>
                                    </v-col>
                                    <v-col class="pa-2" style="background-color: #0672CB">
                                        <div class="my-4 tx-color-white tx-font-bolder tx-font-size32">{{ myPerformanceData.server_Units_LastFourPeriods }}</div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <v-card class="w-100 pa-5 elevation-0" >
                            <v-card-title class="text-subtitle-1"
                                style="background-color: #0C32A4; color:white;"><v-icon
                                    class="mx-2">mdi-nas</v-icon>
                                    <LanguagePlaceholder default-text="Storage+" />
                                    </v-card-title>
                            <v-card-text class="text-center pa-0">
                                <v-row no-gutters class="text-body-1" style="height: 120px;">
                                    <v-col class="pa-2" style="background-color: #58A5E6">

                                        <div class="mt-4 tx-color-white tx-font-normal tx-font-size16">
                                            <LanguagePlaceholder default-text="Total Eligible Units This Incentive Period" />
                                            </div>
                                    </v-col>
                                    <v-col class="pa-2" style="background-color: #0672CB">
                                        <div class="my-4 tx-color-white tx-font-normal tx-font-size16">
                                            <LanguagePlaceholder default-text="Total Eligible Units Last Four Incentive Periods" />
                                            </div>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class="text-body-1" style="color:#58A5E6">
                                    <v-col class="pa-2" style="background-color: #58A5E6">
                                        <div class="mt-4 tx-color-white tx-font-bolder tx-font-size32">{{ myPerformanceData.storage_Units_ThisPeriod }}</div>
                                    </v-col>
                                    <v-col class="pa-2" style="background-color: #0672CB">
                                        <div class="my-4 tx-color-white tx-font-bolder tx-font-size32">{{ myPerformanceData.storage_Units_LastFourPeriods }}
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </div>
                            
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
            </v-row>
        </div>

        <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
            <v-row no-gutters class="bg-color-quartz d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-cobalt tx-color-white mt-5 py-5 px-10 d-flex justify-center w-100 tx-font-normal">  
                        <LanguagePlaceholder is-html
                            default-text="​​​​​​Use the progress bars below to see how many units you need to purchase to hit your reward multiplier thresholds. Your rewards will be multiplied by the amount stated, right back to unit one." />
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
            </v-row>
            <v-row no-gutters class="bg-color-quartz d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-white mb-5 pb-5 d-flex justify-center w-100 tx-font-bold">  
                    <div class="d-flex flex-wrap flex-row ga-10 pt-5">
                            <PartnerRewardsProgress 
                                title="PCs+ Displays+Peripherals" 
                                subTitleLine1="Threshold 1    1.2x Rewards"
                                subTitleLine2="Threshold 2    1.3x Rewards"
                                subTitleLine3="Threshold 3    1.5x Rewards"
                                subTitleLine4="Threshold 4    1.6x Rewards"
                                :labels="['Threshold 4  400 units', 'Threshold 3  250 units', 'Threshold 2    80 units', 'Threshold 1    30 units']" 
                                :units=myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod
                                :totalUnits=myPerformanceData.csG_Units_ThisPeriod
                                :limit1="30" 
                                :limit2="80" 
                                :limit3="250" 
                                :limit4="400" 
                                :reward-loading="false"
                            ></PartnerRewardsProgress>
                            <PartnerRewardsProgress 
                                title="SERVER+" 
                                subTitleLine1="Threshold 1    1.2x Rewards"
                                subTitleLine2="Threshold 2    1.3x Rewards"
                                subTitleLine3="Threshold 3    1.5x Rewards"
                                subTitleLine4="Threshold 4    1.6x Rewards"
                                :labels="['Threshold 4  20 units', 'Threshold 3  15 units', 'Threshold 2  10 units', 'Threshold 1    5 units']" 
                                :units=myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod
                                :totalUnits=myPerformanceData.server_Units_ThisPeriod
                                :limit1="5" 
                                :limit2="10" 
                                :limit3="15" 
                                :limit4="20" 
                                :reward-loading="false"
                            ></PartnerRewardsProgress>
                            <PartnerRewardsProgress 
                                title="STORAGE+" 
                                subTitleLine1="Threshold 1    1.2x Rewards"
                                subTitleLine2="Threshold 2    1.3x Rewards"
                                subTitleLine3="Threshold 3    1.5x Rewards"
                                subTitleLine4="Threshold 4    1.6x Rewards"
                                :labels="['Threshold 4  12 units', 'Threshold 3   8 units', 'Threshold 2   4 units', 'Threshold 1   2 units']" 
                                :units="myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod"
                                :totalUnits="myPerformanceData.storage_Units_ThisPeriod"
                                :limit1="2"
                                :limit2="4"
                                :limit3="8"
                                :limit4="12"
                                :reward-loading="false"
                            ></PartnerRewardsProgress>
                    </div>   
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
            </v-row>
        </div>

        <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
            <v-row no-gutters class="bg-color-quartz d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-white my-5 d-flex justify-center flex-column w-100 tx-font-bold">  
                    <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                        <v-col cols="12" class="d-flex justify-start w-100 pa-0 py-10 ps-10 tx-font-bold bg-color-quartz">  
                            <h1>
                                <LanguagePlaceholder default-text='PCs+ Displays+Peripherals'></LanguagePlaceholder>
                            </h1>   
                        </v-col>
                    </v-row>
                    <v-row justify="end" class="d-none d-md-flex">
                        <v-col md="8">
                            <v-card color="#1D65C0" class="elevation-0">
                                <v-card-text>
                                    <v-row class="d-flex justify-end">
                                        <v-col cols="11" class="bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size16">
                                            <LanguagePlaceholder default-text="Total Eligible Units: " />
                                        </v-col>
                                        <v-col cols="1" class="mt-n2 pe-5 bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size24">
                                            {{ myPerformanceData.csG_Units_ThisPeriod }}
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex justify-end">
                                        <v-col cols="11" class="bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size16">
                                            <LanguagePlaceholder default-text="Units that count towards Reward Multiplier Thresholds: " />                                        
                                        </v-col>
                                        <v-col cols="1" class="mt-n2 pe-5 bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size24">
                                            {{ myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod }}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="end" class="d-none d-md-flex">
                        <v-col md="12">
                            <v-timeline direction="horizontal">
                                <v-timeline-item
                                    :dot-color="myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod >= 30 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod >= 30 && myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod < 80">
                                            {{ myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod }} Units
                                            Achieved
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 1" />
                                            
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.2x Rewards)" /> 
                                        </div>
                                        <div> <LanguagePlaceholder default-text="(30 Units)" /> </div>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item
                                    :dot-color="myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod >= 80 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod >= 80 && myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod < 250">
                                            {{ myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod }} Units
                                            Achieved
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 2" /> 
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.3x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(80 Units)" /> </div>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item
                                    :dot-color="myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod >= 250 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod >= 250 && myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod < 400">
                                            {{ myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod }} Units
                                            Achieved
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 3" />
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.5x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(250 Units)" /></div>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item
                                    :dot-color="myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod >= 400 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod >= 400">
                                            {{ myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod }} Units
                                            Achieved
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 4" />
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.6x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(400 Units)" /></div>
                                    </div>
                                </v-timeline-item>
                            </v-timeline>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="6">
                            <v-card height="100" color="#0d2155">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Total Eligible Units:" /></div>
                                    <div><strong>{{ myPerformanceData.csG_Units_ThisPeriod }}</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="6">
                            <v-card height="100" color="#0d2155">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units that count towards Reward Multiplier Thresholds:" />
                                    </div>
                                    <div><strong>{{ myPerformanceData.csG_UnitsCountTowardThreshold_ThisPeriod
                                            }}</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 1 (30 Units | 1.2x Rewards)" />
                                    </div>
                                    <div><strong>30</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 2 (80 Units | 1.3x Rewards)" />
                                    </div>
                                    <div><strong>80</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 3 (250 Units | 1.5x Rewards)" />
                                    </div>
                                    <div><strong>250</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 4 (400 Units | 1.6x Rewards)" />
                                    </div>
                                    <div><strong>400</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-card tile flat>
                                <v-toolbar density="compact" color="#EEEEEE">
                                    <v-spacer></v-spacer>
                                    <v-btn icon="mdi-download" @click="downloadFile_csg"><v-icon size="large">mdi-download</v-icon></v-btn>
                                </v-toolbar>
                                <v-card-text class="pa-0">
                                    <v-text-field v-model="searchStringPCDP" style="color:545454"  label="Filter" prepend-inner-icon="mdi-filter-outline"
                                        variant="outlined" hide-details single-line
                                        aria-label="Filter on PCs+ Displays+Peripherals"></v-text-field>                    
                                    <v-data-table :items-per-page="10" :headers="headers" :search="searchStringPCDP"
                                        :items="myPerformanceData.csG_Transactions_ThisPeriod" item-key="name" class="v-data-table-row"
                                        >
                                        <template v-slot:item.rewards="{ item }">
                                            {{ $filters.currencyUSD(item.rewards) }}
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
            </v-row>
        </div>

        <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
            <v-row no-gutters class="bg-color-quartz d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-white my-5 d-flex justify-center flex-column w-100 tx-font-bold">  
                    <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                        <v-col cols="12" class="d-flex justify-start w-100 pa-0 py-10 ps-10 tx-font-bold bg-color-quartz">  
                            <h1>
                                <LanguagePlaceholder default-text='Server+'></LanguagePlaceholder>
                            </h1>   
                        </v-col>
                    </v-row>
                    <v-row justify="end" class="d-none d-md-flex">
                        <v-col md="8">
                            <v-card color="#1D65C0" class="elevation-0">
                                <v-card-text>                                    
                                    <v-row class="d-flex justify-end">
                                        <v-col cols="11" class="bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size16">
                                            <LanguagePlaceholder default-text="Total Eligible Units: " />
                                        </v-col>
                                        <v-col cols="1" class="mt-n2 pe-5 bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size24">
                                            {{ myPerformanceData.server_Units_ThisPeriod }}
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex justify-end">
                                        <v-col cols="11" class="bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size16">
                                            <LanguagePlaceholder default-text="Units that count towards Reward Multiplier Thresholds: " />
                                        </v-col>
                                        <v-col cols="1" class="mt-n2 pe-5 bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size24">
                                            {{ myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod }}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="end" class="d-none d-md-flex">
                        <v-col md="12">
                            <v-timeline direction="horizontal">
                                <v-timeline-item
                                    :dot-color="myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod >= 5 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod >= 5 && myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod < 10">
                                            {{ myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod }} 
                                            <LanguagePlaceholder default-text="Units Achieved" />
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 1" />
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.2x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(5 Units)" /></div>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item
                                    :dot-color="myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod >= 10 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod >= 10 && myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod < 15">
                                            {{ myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod }} 
                                            <LanguagePlaceholder default-text="Units Achieved" />
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 2" />
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.3x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(10 Units)" /></div>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item
                                    :dot-color="myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod >= 15 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod >= 15 && myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod < 20">
                                            {{ myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod }} 
                                            <LanguagePlaceholder default-text="Units Achieved" />
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">

                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 3" />
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.5x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(15 Units)" /></div>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item
                                    :dot-color="myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod >= 20 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod >= 20">
                                            {{ myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod }} 
                                            <LanguagePlaceholder default-text="Units Achieved" />
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 4" />
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.6x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(20 Units)" /></div>
                                    </div>
                                </v-timeline-item>
                            </v-timeline>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="6">
                            <v-card height="100" color="#0d2155">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Total Eligible Units:" /></div>
                                    <div><strong>{{ myPerformanceData.server_Units_ThisPeriod }} </strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="6">
                            <v-card height="100" color="#0d2155">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units that count towards Reward Multiplier Thresholds:" />
                                    </div>
                                    <div><strong>{{ myPerformanceData.server_UnitsCountTowardThreshold_ThisPeriod }}
                                        </strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 1 (5 Units | 1.2x Rewards)" /></div>
                                    <div><strong>5</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 2 (10 Units | 1.3x Rewards)" />
                                    </div>
                                    <div><strong>10</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 3 (15 Units | 1.5x Rewards)" />
                                    </div>
                                    <div><strong>15</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 4 (20 Units | 1.6x Rewards)" />
                                    </div>
                                    <div><strong>20</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-card tile flat>
                                <v-toolbar density="compact" color="#EEEEEE">
                                    <v-spacer></v-spacer>
                                    <v-btn icon="mdi-download" @click="downloadFile_server"><v-icon size="large">mdi-download</v-icon></v-btn>
                                </v-toolbar>
                                <v-card-text class="pa-0">
                                    <v-text-field v-model="searchStringServer" style="color:545454"  label="Filter" prepend-inner-icon="mdi-filter-outline"
                                        variant="outlined" hide-details single-line
                                        aria-label="Filter on Server Plus"></v-text-field> 
                                    <v-data-table :items-per-page="10" :headers="headers" :search="searchStringServer"
                                        :items="myPerformanceData.server_Transactions_ThisPeriod" item-key="name" class="v-data-table-row">
                                        <template v-slot:item.rewards="{ item }">
                                            {{ $filters.currencyUSD(item.rewards) }}
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
            </v-row>
        </div>

        <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
            <v-row no-gutters class="bg-color-quartz d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-white my-5 d-flex justify-center flex-column w-100 tx-font-bold">  
                    <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                        <v-col cols="12" class="d-flex justify-start w-100 pa-0 py-10 ps-10 tx-font-bold bg-color-quartz">  
                            <h1>
                                <LanguagePlaceholder default-text='Storage+'></LanguagePlaceholder>
                            </h1>   
                        </v-col>
                    </v-row>
                    <v-row justify="end" class="d-none d-md-flex">
                        <v-col md="8">
                            <v-card color="#1D65C0" class="elevation-0">
                                <v-card-text>
                                     <v-row class="d-flex justify-end">
                                        <v-col cols="11" class="bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size16">
                                            <LanguagePlaceholder default-text="Total Eligible Units:" /> 
                                        </v-col>
                                        <v-col cols="1" class="mt-n2 pe-5 bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size24">
                                            {{ myPerformanceData.storage_Units_ThisPeriod }}
                                        </v-col>
                                    </v-row>
                                    <v-row class="d-flex justify-end">
                                        <v-col cols="11" class="bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size16">
                                            <LanguagePlaceholder default-text="Units that count towards Reward Multiplier Thresholds:" />
                                        </v-col>
                                        <v-col cols="1" class="mt-n2 pe-5 bg-color-cobalt text-right tx-color-white tx-font-bolder tx-font-size24">
                                            {{ myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod }}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="end" class="d-none d-md-flex">
                        <v-col md="12">
                            <v-timeline direction="horizontal">
                                <v-timeline-item
                                    :dot-color="myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod >= 2 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod >= 2 && myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod < 4">
                                            {{ myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod }} 
                                            <LanguagePlaceholder default-text="Units Achieved" />
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 1" />
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.2x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(2 Units)" /></div>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item
                                    :dot-color="myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod >= 4 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod >= 4 && myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod < 8">
                                            {{ myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod }} Units
                                            Achieved
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 2" />
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.3x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(4 Units)" /></div>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item
                                    :dot-color="myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod >= 8 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod >= 8 && myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod < 12">
                                            {{ myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod }} 
                                            <LanguagePlaceholder default-text="Units Achieved" />
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">

                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 3" />
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.5x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(8 Units)" /></div>
                                    </div>
                                </v-timeline-item>
                                <v-timeline-item
                                    :dot-color="myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod >= 12 ? 'light-green' : '#0C32A4'"
                                    size="small">
                                    <template v-slot:opposite>
                                        <v-chip variant="elevated" color="light-green-darken-3"
                                            v-if="myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod >= 12">
                                            {{ myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod }} 
                                            <LanguagePlaceholder default-text="Units Achieved" />
                                        </v-chip>
                                    </template>
                                    <div class="text-body-2 text-center">
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="Threshold 4" />
                                        </div>
                                        <div class="text-subtitle-2">
                                            <LanguagePlaceholder default-text="(1.6x Rewards)" />
                                        </div>
                                        <div><LanguagePlaceholder default-text="(12 Units)" /></div>
                                    </div>
                                </v-timeline-item>
                            </v-timeline>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="6">
                            <v-card height="100" color="#0d2155">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Total Eligible Units:" /></div>
                                    <div><strong>{{ myPerformanceData.storage_Units_ThisPeriod }} </strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="6">
                            <v-card height="100" color="#0d2155">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units that count towards Reward Multiplier Thresholds:" />
                                    </div>
                                    <div><strong>{{ myPerformanceData.storage_UnitsCountTowardThreshold_ThisPeriod }}
                                        </strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 1 (2 Units | 1.2x Rewards)" /></div>
                                    <div><strong>2</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 2 (4 Units | 1.3x Rewards)" />
                                    </div>
                                    <div><strong>4</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 3 (8 Units | 1.5x Rewards)" />
                                    </div>
                                    <div><strong>8</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="d-sm-flex d-md-none">
                        <v-col cols="12">
                            <v-card color="#0672cb">
                                <v-card-text class="text-center">
                                    <div class="text--white"><LanguagePlaceholder default-text="Units to Achieve Threshold 4 (12 Units | 1.6x Rewards)" />
                                    </div>
                                    <div><strong>12</strong></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-card tile flat>
                                <v-toolbar density="compact" color="#EEEEEE">
                                    <v-spacer></v-spacer>
                                    <v-btn icon="mdi-download" @click="downloadFile_storage"><v-icon size="large">mdi-download</v-icon></v-btn>
                                </v-toolbar>
                                <v-card-text class="pa-0">
                                    <v-text-field v-model="searchStringStorage" style="color:545454" label="Filter" prepend-inner-icon="mdi-filter-outline"
                                        variant="outlined" hide-details single-line
                                        aria-label="Filter on Storage"></v-text-field> 
                                    <v-data-table :items-per-page="10" :headers="headers" :search="searchStringStorage"
                                        :items="myPerformanceData.storage_Transactions_ThisPeriod" item-key="name" class="v-data-table-row">
                                        <template v-slot:item.rewards="{ item }">
                                            {{ $filters.currencyUSD(item.rewards) }}
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
            </v-row>
        </div>
            
    </div>

</template>


<script setup>
import { ref, onMounted } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import imgUrl_my_performance from '@/assets/img/banner/blue_myperformance.jpg'
import PartnerRewardsProgress from '@/components/PartnerRewardsProgress.vue'
import { useExcelStore } from '@/stores/excel'

const systemStore = useSystemStore()
const excelStore = useExcelStore()

const quarters = ref([])
const selectedQuarter = ref('')
const myPerformanceData = ref({})
const rewardLoading = ref(false)

const searchStringPCDP = ref('')
const searchStringServer = ref('')
const searchStringStorage = ref('')

onMounted(() => {
    systemStore.getQuarters().then(result => {
    if (result.success) {
        quarters.value = result.quarters
                .filter(q => q.currentQuarters === true)
                .map(q => q.quarter)
      
      selectedQuarter.value = result.quarters.find(q => q.currentQuarter === true)?.quarter

      getData()
    }
    }).catch(error => {
      console.log('recalculateLocalValue', error)
    })
})

const getData = () => {
    rewardLoading.value = true
    systemStore.getMyPerformanceData(systemStore.userDetail.affinityId, selectedQuarter.value).then(result => {
        myPerformanceData.value = result
        rewardLoading.value = false
    })
}

const clickSubmit = () => {
    getData()
}

const downloadFile_csg = () => {
    if (myPerformanceData.value.csG_Transactions_ThisPeriod.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelDocument(myPerformanceData.value.csG_Transactions_ThisPeriod, 'MyPerformanceDocument').catch(error => {
        console.log('Generate In Memory Excel Document - CSG', error)
    })
}

const downloadFile_server = () => {
    if (myPerformanceData.value.server_Transactions_ThisPeriod.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelDocument(myPerformanceData.value.server_Transactions_ThisPeriod, 'MyPerformanceDocument').catch(error => {
        console.log('Generate In Memory Excel Document - CSG', error)
    })
}

const downloadFile_storage = () => {
    if (myPerformanceData.value.storage_Transactions_ThisPeriod.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelDocument(myPerformanceData.value.storage_Transactions_ThisPeriod, 'MyPerformanceDocument').catch(error => {
        console.log('Generate In Memory Excel Document - CSG', error)
    })
}


// cellProps
const headers = [
    { title: 'Product Group', value: 'productGroup', sortable: true, headerProps: { class: 'v-data-table-header' } },
    { title: 'Quantity', value: 'quantity', sortable: true, headerProps: { class: 'v-data-table-header' } },
    { title: '$ Rewards', value: 'rewards', sortable: true, headerProps: { class: 'v-data-table-header' } },
    { title: 'Counts Towards Threshold', value: 'countTowardsThreshold', sortable: true, headerProps: { class: 'v-data-table-header' } },
    { title: 'Eligible Partner', value: 'eligiblePartner', sortable: true, headerProps: { class: 'v-data-table-header' } },
    { title: 'Eligible Product', value: 'eligibleProduct', sortable: true, headerProps: { class: 'v-data-table-header' } },
    { title: 'Eligible Distributor', value: 'eligibleDistributor', sortable: true, headerProps: { class: 'v-data-table-header' } },
]

const items = [

]

</script>

<style scoped>

</style>